import React, { useEffect } from 'react';
import { useAppState } from '../../contexts/appState';
import { handleFaqChange } from '../../reducersAndActions/actions/appStateActions';

export default function FaqWrapper(OrginalComponent) {
  function NewComponent(props) {
    const [, dispatch] = useAppState();

    useEffect(() => {
      handleFaqChange(dispatch, true);
      return () => {
        setTimeout(() => {
          handleFaqChange(dispatch, false);
        }, 0);
      };
    }, []);
    return <OrginalComponent {...props} />;
  }
  return NewComponent;
}
